import { Box } from "@chakra-ui/react";
import {  useSelector } from "react-redux";

function Protected({ children, permissionRequired="", shouldIgnorePermission=false }) {
  const userData = useSelector((state) => {
    return state?.protectedRoute?.userData;
  });
  const protectedPlaceholder =<Box p={"20px"} boxSizing={"border-box"} fontSize={"30px"} fontWeight={"bold"}>This Page is Protected</Box>;
  // TODO: Should uncomment once activation feature is enable. 
  if (userData === undefined 
  || !userData?.isActive
  ) return protectedPlaceholder;

  if (shouldIgnorePermission){
    return children;
  }
  
  const hasPermission = userData.permissions.includes(permissionRequired) && userData.isActive;

  return hasPermission ? children : protectedPlaceholder;
}

export default Protected;
